<template>
  <div v-if="isRouterAlive">
    <b-container ref="about10">
      <b-row class="justify-content-md-left about-content-1">
        <b-col cols="12" md="2" lgt="2">
          <span class="about-title">{{ $t("titlet1") }}</span></b-col
        >
        <b-col cols="12" md="10" lgt="10">
          <b-img
            :src="$t('contentt1')"
            fluid
            alt="宁波天鑫仪表有限公司"
          ></b-img>
          <div class="row about-content-info" v-html="$t('contentt2')"></div>
        </b-col>
      </b-row>
    </b-container>
    <div class="about-content-2 w-100 mt-5 mb-5">
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="10" lg="8">
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="10" lg="10">
              <div class="about-img-content row">
                <div class="col-4">
                  <b-img
                    src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/about/about-t-01.svg"
                    fluid
                    alt="宁波天鑫仪表有限公司"
                  ></b-img>
                </div>
                <div class="col-4">
                  <b-img
                    src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/about/about-t-02.svg"
                    fluid
                    alt="宁波天鑫仪表有限公司"
                  ></b-img>
                </div>
                <div class="col-4">
                  <b-img
                    src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/about/about-t-03.svg"
                    fluid
                    alt="宁波天鑫仪表有限公司"
                  ></b-img>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <b-container>
      <b-row class="justify-content-md-center about-content-1">
        <b-col cols="12" md="10" lgt="10">
          <div
            class="row justify-content-md-center about-content-info"
            v-html="$t('contentt3')"
          >
            <!-- <div class="col-10">
              <div class="info-title">企业规模</div>
              目前企业员工200余人，拥有500余台生产及检测设备，形成了年产50万台智能燃气表和1000万米不锈钢软管及配套管件.阀门的生产能力。同时可定制DN4-DN2000不同规格波纹金属软管、金属波纹管膨胀节，年生产能力30万台套。
            </div>
            <div class="col-10">
              <div class="info-title">企业产品</div>
              专业燃气仪表及不锈钢波纹软管及管件、阀门、燃气用具连接用金属包覆软管、波纹金属软管、金属软管膨胀节。
            </div>
            <div class="col-10">
              <div class="info-title">标准及资质</div>
              公司是CJ/T296-2008《燃气用非定尺不锈钢波纹管及接头》、GB/T26002-2010《燃气输送用不锈钢波纹软管及管件》、CJ/T197-2010《燃气用具连接用不锈钢波纹软管》、CJ/T490-2016《燃气用具连接用金属包覆软管》、GB/T《燃气用具连接用不锈钢波纹软管》、CJ-T449-2014《切断型膜式燃气表》、DJ/T503-2016《无线远传膜式燃气表》等标准的起草单位，公司通过GB/T19001-2016/ISO9001:2015
              质量管理体系认证、GB/T24001-2016/ISO14001:2015环境管理体系认证、ISO45001:2018职业健康安全管理体系认证，取得特种设备制造许可证(压力管道)和燃气产品认证，同时获得多项国家专利证书。
            </div>
            <div class="col-10">
              <div class="info-title">销售团队及网络</div>
              公司拥有高效、专业的销售服务团队，在全国已构建完善“天鑫”品牌销售服务网络，与诸多大型城市燃气运营商和燃气具制造商建立长期稳定合作关系，成为国内最具影响力和竞争力的不锈钢软管系列产品生产及服务商之一。
            </div> -->
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container ref="about11">
      <b-row class="justify-content-md-left about-content-1">
        <b-col cols="12" md="2" lgt="2">
          <span class="about-title">{{ $t("titlet2") }}</span></b-col
        >
        <b-col cols="12" md="10" lgt="10">
          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="b-bg">
                <b-img
                  style="height: 55px"
                  src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/about/about-b-01.svg"
                  fluid
                  alt="宁波天鑫仪表有限公司"
                ></b-img>
                <div class="slogn">{{ $t("contentt4") }}</div>
                <div class="info">{{ $t("contentt5") }}</div>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="b-bg">
                <b-img
                  style="height: 55px"
                  src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/about/about-b-01.svg"
                  fluid
                  alt="宁波天鑫仪表有限公司"
                ></b-img>
                <div class="slogn">{{ $t("contentt6") }}</div>
                <div class="info">{{ $t("contentt7") }}</div>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="b-bg">
                <b-img
                  style="height: 55px"
                  src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/about/about-b-01.svg"
                  fluid
                  alt="宁波天鑫仪表有限公司"
                ></b-img>
                <div class="slogn">{{ $t("contentt8") }}</div>
                <div class="info">{{ $t("contentt9") }}</div>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="b-bg">
                <b-img
                  style="height: 55px"
                  src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/about/about-b-01.svg"
                  fluid
                  alt="宁波天鑫仪表有限公司"
                ></b-img>
                <div class="slogn">{{ $t("contentt10") }}</div>
                <div class="info">{{ $t("contentt11") }}</div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Sticky from "sticky-js";
export default {
  props: {
    active: {
      type: Number,
    },
  },
  watch: {
    active(v) {
      console.log(v);
      this.reloadview();
    },
  },
  components: {},
  data() {
    return {
      isRouterAlive: true,

      visible1: false,
    };
  },
  computed: {
    colarrowdown() {
      return this.$store.state.colarrowdown;
    },
    colarrowup() {
      return this.$store.state.colarrowup;
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    reloadview() {
      const _this = this;
      console.log(_this.$refs.about10);
      console.log(_this.$refs.about11);
      this.$nextTick(function() {
        switch (_this.active) {
          case 0:
            if (_this.$refs.about10) {
              _this.$refs.about10.scrollIntoView();
            }
            // document.getElementById("about1-0").scrollIntoView();
            break;
          case 1:
            if (_this.$refs.about11) {
              _this.$refs.about11.scrollIntoView();
            }
            // document.getElementById("about1-1").scrollIntoView();
            break;
        }
      });
    },
    getAbout1Page() {
      const _this = this;
      this.$store.dispatch("getAbout1Page").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);
        let lang = _this.$i18n.locale;
        _this.$i18n.locale = lang;
        _this.reload();
        const sticky2 = new Sticky(".sticky2");
        sticky2.update();
      });
    },
  },
  updated() {
    this.reloadview();
  },
  mounted() {
    this.getAbout1Page();
  },
  created() {},
};
</script>
<style>
.slider-title {
  margin-left: 115px;
  color: #fff;
  font-size: 42px;
  font-weight: bold;
}
.slider-subtitle {
  margin-left: 115px;
  color: #fff;
  font-size: 20px;
  font-weight: 100;
}
.news-title-group {
  z-index: 1777;
  background-color: #fff;
  border-bottom: 0.5px #bdbdbd88 solid;
}
.news-title {
  padding: 20px 0;
  cursor: pointer;
}
.news-title span {
  padding: 22px 0;
}
.news-title span:hover {
  color: #c00f31;
  font-weight: 800;
  border-bottom: 3px solid #c00f31;
}
.news-title.active span {
  border-bottom: 3px solid #c00f31;
}
.news-title.active {
  color: #c00f31;
  font-weight: 800;
}
.news-list {
  padding-bottom: 100px;
}
.page-item.active .page-link {
  color: #c00f31;
  background-color: #ffffff00;
}
.page-link {
  color: #000;
  border: 0;
}
.page-link:hover {
  color: #c00f31;
}
.pagestyle {
  color: #000;
  padding: 6px 10px;
  border: 0.5px #bdbdbd88 solid;
}
.pagestyle:hover {
  background-color: #00000000;
  color: #c00f31;
}
.page-item:hover {
  background-color: #00000000;
}
.news-pagination {
  margin-top: 100px;
}
.news-item {
  margin-top: 50px;
  cursor: pointer;
}

.news-item:hover {
  -webkit-box-shadow: #00000034 0px 0px 10px;
  -moz-box-shadow: #00000034 0px 0px 10px;
  box-shadow: #00000034 0px 0px 10px;
}
.news-body {
  padding: 10px 30px 20px 30px;
  background-color: #ededed;
}
.product-item-body-head {
  font-size: 12px;
}
.product-item-date {
  font-size: 12px;
  font-weight: 200;
  color: #8a8a8a;
  margin-left: 10px;
}
.product-item-type {
  background-color: #c00f31;
  color: #ffffff;
  padding: 0 5px;
  margin-left: 15px;
}
.news-item-title {
  font-weight: bold;
  font-size: 16px;
  color: #000;
}
.news-item-info {
  margin-top: 30px;
  font-size: 12px;
  color: #8a8a8a;
}
@media only screen and (max-width: 500px) {
  .slider-title {
    margin-left: 65px;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
  }
  .slider-subtitle {
    margin-left: 65px;
    color: #fff;
    font-size: 10px;
    font-weight: 100;
  }
}
.about-content-1 {
  margin-top: 50px;
  margin-bottom: 50px;
}
.about-title {
  font-size: 25px;
  font-weight: bold;
  border-bottom: 2px #c00f31 solid;
  margin-bottom: 50px;
  white-space: nowrap;
}
.about-content-info {
  color: #666666;
  font-weight: 400;
  font-size: 12px;
}

.about-content-info div {
  margin-top: 20px;
}
.about-content-2 {
  min-height: 260px;
  background: url(https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/about/about-bg-01.jpg)
    no-repeat top center scroll;
  background-size: cover;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
}

.about-content-2 img {
  height: 110px;
  margin-top: 40px;
}
.about-img-content {
  background-color: #fff;
  min-height: 220px;
}
.info-title {
  color: #000;
  font-size: 15px;
  font-weight: bold;
}
.b-bg {
  background-color: #ededed;
  text-align: center;
  padding: 50px 0;
  margin-bottom: 30px;
}

.b-bg .slogn {
  font-weight: bold;
}
.b-bg .info {
  font-weight: 200;
}

.news-title-thin {
  display: none;
}
@media only screen and (max-width: 500px) {
  .news-title-wide {
    display: none;
  }
  .news-title-thin {
    display: block;
  }
  .news-title-button img {
    width: 15px;
    position: absolute;
    right: 30px;
  }
  .news-title-header {
    font-size: 15px;
    font-weight: bold;
    padding: 10px 0;
    border-bottom: 1px #bdbdbd44 solid;
  }
}
</style>
